export default __webpack_public_path__ + "static/media/finance5.fa5091cb.mp4";